import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tsyrm2cvwb: FaireBrandEntity = {
  token: "b_tsyrm2cvwb",
  type: "brand",
  name: "Lost Pattern NYC",
  avatarUrl:
    "https://cdn.faire.com/fastly/063e98d4f75208000c4e140fb5e5e5eb8e2c1702201fcd9ee2d20b03f3f51997.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f1236ab2eccdc90ade36a72eaa8aff484ee1d6c9ea7ccdd802c49fa3c82a9343.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/063e98d4f75208000c4e140fb5e5e5eb8e2c1702201fcd9ee2d20b03f3f51997.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f1236ab2eccdc90ade36a72eaa8aff484ee1d6c9ea7ccdd802c49fa3c82a9343.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 35,
  isTopShop: true,
  isInsider: true,
  description:
    "Lost Pattern is a New York City-based designer accessory and lifestyle brand that redefines silk as fun and modern while celebrating every self-expression and identity. \n\nMindfully sourced and sustainably handcrafted, Lost Pattern honors traditional craftsmanship and is committed to turning conscious fashion into a lifestyle. All of our square scarves are hand rolled and stitched, a tradition we maintain and celebrate. All clothing, hat pieces and tote bags are hand made in our studios by our local artisans. Our products are loved by customers of boutiques and stores across the US including Wolf & Badger, Anthropologie etc.\n\nWe also pride ourselves in custom made accessories. With custom logo, personalized design, volume discounts, and dedicated support, you can easily create your own premium products or gifts for any occasions, with the standard of Lost Pattern products.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:50.828Z",
    importedBy: "entity-db-cli",
  },
};
